import { render, staticRenderFns } from "./AppChecklistsNewDialog.vue?vue&type=template&id=f703740e&scoped=true&"
import script from "./AppChecklistsNewDialog.vue?vue&type=script&lang=js&"
export * from "./AppChecklistsNewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f703740e",
  null
  
)

export default component.exports